import { logger } from '@lessonup/client-integration';
import { PollPinSettings } from '@lessonup/pins-shared';
import React from 'react';
import { EmojiPollAnswerAreaContent } from './components/EmojiPollAnswerAreaContent';
import { TextPollAnswerAreaContent } from './components/TextPollAnswerAreaContent';

export interface PollAnswerAreaContentProps {
  pinSettings: PollPinSettings;
  isInteractive?: boolean;
  selectedAnswerId?: string;
  onAnswerClick?: (answerId: string) => void;
}

export function PollAnswerAreaContent({
  pinSettings,
  isInteractive = false,
  selectedAnswerId,
  onAnswerClick,
}: PollAnswerAreaContentProps) {
  switch (pinSettings.type) {
    case 'EMOJI':
      return (
        <EmojiPollAnswerAreaContent
          pinSettings={pinSettings}
          isInteractive={isInteractive}
          selectedAnswerId={selectedAnswerId}
          onAnswerClick={onAnswerClick}
        />
      );
    case 'TEXT':
      return (
        <TextPollAnswerAreaContent
          pinSettings={pinSettings}
          isInteractive={isInteractive}
          selectedAnswerId={selectedAnswerId}
          onAnswerClick={onAnswerClick}
        />
      );
    default:
      logger.error(`Unknown PollPin type`);
      return null;
  }
}
